/**
 * @author wangjunfeng
 */
import SyHeader from './header'
export default SyHeader
